// billing-plugin/common/schemas/collections/billingPlans.js
import { z } from "zod";
import  RecurrenceRuleSchema  from "./recurrenceRule.js";

export const PlanFeatureLinkSchema = z.object({
    featureKey: z.string().describe("The key of the BillableFeature to include."),
    overrides: z.object({
        name: z.string().optional(),
        billerConfig: z.record(z.any()).optional(),
        unitCost: z.number().int().optional(),
        oneTimeFee: z.number().int().optional(),
        recurringFee: z.number().int().optional(),
        freeUnits: z.number().int().optional(),
        maxUnits: z.number().int().positive().optional().nullable(),
    }).optional(),
});

const BillingPlanSchema = z.object({
    _id: z.string().optional(),
    planId: z.string(),
    name: z.string().min(1),
    description: z.string().optional(),
    currency: z.string().length(3),
    
    oneTimeCost: z.number().int().default(0),
    recurringCost: z.number().int().default(0),
    initialBalance: z.number().int().default(0),

    billingCycleRule: RecurrenceRuleSchema.describe("The rule defining the plan's main billing cycle."),
    isLifetime: z.boolean().default(false).describe("If true, this plan has no recurring cost after the initial payment."), // NEW

    features: z.array(PlanFeatureLinkSchema),
    
    isPublic: z.boolean().default(true),
    isArchived: z.boolean().default(false),
    metadata: z.record(z.any()).optional(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default BillingPlanSchema;